import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { GenericService } from 'src/app/services/generic.service';
import { TvProductionTrackerService } from 'src/app/services/tv-production-tracker.service';

@Component({
  selector: 'app-tv-production-tracker-calendar',
  templateUrl: './tv-production-tracker-calendar.component.html',
  styleUrls: ['./tv-production-tracker-calendar.component.css']
})
export class TvProductionTrackerCalendarComponent implements OnInit {

  currentDate: Date = new Date();
  todayDate: Date = new Date();
  calendarDays: any[] = [];

  weekDays: any[] = [];
  dayEvents: any[] = [];
  todaysEpisodes: any[] = [];
  upcomingDeadlines: any[] = [];
  episodeList: any[] = [];
  isLoading: boolean = false;
  selectedEpisode: any = null;
  currentView: string = 'Month';

  // Filters
  searchKey: string = '';
  startDate: any = '';
  endDate: any = '';
  priority: string = '';
  episodeType: string = '';
  episodeStatus: string = '';
  loggedInUserId: any;


  episodeForm: any | FormGroup;
  formSubmit: boolean = false;
  isEdit: boolean = false;
  cid: any;
  anchorUserList: any[] = [];
  directorUserList: any[] = [];
  userList: any = []

  episodeStatuses = [
    { key: 'CREATED', label: 'Created' },
    { key: 'EDITOR_ASSIGNED', label: 'Editor Assigned' },
    { key: 'EDIT_COMPLETED', label: 'Edit Completed' },
    { key: 'TITLE_ASSIGNED', label: 'Title Assigned' },
    { key: 'TITLE_COMPLETED', label: 'Title Completed' },
    { key: 'GRAPHICS_ASSIGNED', label: 'Graphics Assigned' },
    { key: 'GRAPHICS_COMPLETED', label: 'Graphics Completed' },
    { key: 'SEO_ASSIGNED', label: 'SEO Assigned' },
    { key: 'SEO_COMPLETED', label: 'SEO Completed' },
    { key: 'QUALITY_CHECK_ASSIGNED', label: 'Quality Check Assigned' },
    { key: 'QUALITY_CHECK_COMPLETED', label: 'Quality Check Completed' },
    { key: 'PUBLISHING_ASSIGNED', label: 'Publishing Assigned' },
    { key: 'PUBLISHING_COMPLETED', label: 'Publishing Completed' },
    { key: 'COMPLETED', label: 'Completed' },
    { key: 'PENDING', label: 'Pending' },
    { key: 'EPISODE_CREATION', label: 'Episode Creation' }
  ];

  episodeTypes: string[] = [
    'Full Episode',
    'Interview',
    'Shorts',
    'Live Event',
    'Promo',
    'News'
  ];

  priorities: string[] = [
    'LOW',
    'MEDIUM',
    'HIGH'
  ];

  statusMap: any = {
    'CREATED': 'Created',
    'EDITOR_ASSIGNED': 'Editor Assigned',
    'EDIT_COMPLETED': 'Edit Completed',
    'TITLE_ASSIGNED': 'Title Assigned',
    'TITLE_COMPLETED': 'Title Completed',
    'GRAPHICS_ASSIGNED': 'Graphics Assigned',
    'GRAPHICS_COMPLETED': 'Graphics Completed',
    'SEO_ASSIGNED': 'SEO Assigned',
    'SEO_COMPLETED': 'SEO Completed',
    'QUALITY_CHECK_ASSIGNED': 'Quality Check Assigned',
    'QUALITY_CHECK_COMPLETED': 'Quality Check Completed',
    'PUBLISHING_ASSIGNED': 'Publishing Assigned',
    'PUBLISHING_COMPLETED': 'Publishing Completed',
    'COMPLETED': 'Completed',
    'PENDING': 'Pending',
    'EPISODE_CREATION': 'Episode Creation'
  };

  constructor(
    private tvProductionTrackerService: TvProductionTrackerService,
    private fb: FormBuilder,
    private toastr: ToastrService, private genericService: GenericService,
  ) { }

  ngOnInit(): void {
    this.cid = Number(sessionStorage.getItem('cid'));
    this.loggedInUserId = Number(sessionStorage.getItem('userId')) || 0;
    this.generateCalendarDays();
    this.todaySchedule();
    this.fetchUpcomingDeadlines();
    this.getAllUsers()
    this.episodeForm = this.fb.group({
      episodeName: ['', [Validators.required]],
      episodeType: ['', [Validators.required]],
      episodeYouTubeURL: [''],
      anchorUser: [''],
      guest1: [''],
      guest2: [''],
      director: [''],
      shootDate: ['', [Validators.required]],
      shootTime: ['']
    });
  }

  getAllUsers() {
    this.genericService.getUsersWithoutCustomers().subscribe(
      (res: any) => {
        console.log(res)
        if (res && res.response) {
          this.userList = res.response;
          this.anchorUserList = this.userList.filter((u: any) => u.userType === 'ANCHOR');
          this.directorUserList = this.userList.filter((u: any) => u.userType === 'DIRECTOR');
        }
      },
      (err: any) => {
        console.error(err);
      }
    );
  }

  get editingDueCount(): number {
    return this.upcomingDeadlines.filter(e => e.currentStage === 'EDITOR_ASSIGNED' || e.currentStage === 'EDITOR').length;
  }

  get graphicsDueCount(): number {
    return this.upcomingDeadlines.filter(e => e.currentStage === 'GRAPHICS_ASSIGNED' || e.currentStage === 'GRAPHICS').length;
  }

  get qcPendingCount(): number {
    return this.upcomingDeadlines.filter(e => e.currentStage === 'QUALITY_CHECK_ASSIGNED' || e.currentStage === 'QUALITY_CHECK').length;
  }

  get publishingDueCount(): number {
    return this.upcomingDeadlines.filter(e => e.currentStage === 'PUBLISHING_ASSIGNED' || e.currentStage === 'PUBLISHING').length;
  }

  fetchUpcomingDeadlines() {
    const today = new Date();
    const startTimestamp = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0, 0).getTime();

    // Add 1 month for end date
    const oneMonthLater = new Date(today);
    oneMonthLater.setMonth(oneMonthLater.getMonth() + 1);
    const endTimestamp = new Date(oneMonthLater.getFullYear(), oneMonthLater.getMonth(), oneMonthLater.getDate(), 23, 59, 59, 999).getTime();

    const payload = {
      startDate: startTimestamp,
      endDate: endTimestamp,
      priority: null,
      episodeType: null,
      episodeStatus: null
    };

    const cid = Number(sessionStorage.getItem('cid')) || 0;

    this.tvProductionTrackerService.filterTvProductionTracker(cid, payload).subscribe(
      (res: any) => {
        console.log(res.response)
        if (res && res.response) {
          this.upcomingDeadlines = Array.isArray(res.response) ? res.response : [res.response];
        } else {
          this.upcomingDeadlines = [];
        }
      },
      (err: any) => {
        console.error("Error fetching upcoming deadlines", err);
        this.upcomingDeadlines = [];
      }
    );
  }

  todaySchedule() {
    const today = new Date();
    const startTimestamp = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0, 0).getTime();
    const endTimestamp = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59, 999).getTime();

    const payload = {
      startDate: startTimestamp,
      endDate: endTimestamp,
      priority: null,
      episodeType: null,
      episodeStatus: null
    };

    const cid = Number(sessionStorage.getItem('cid')) || 0;

    this.tvProductionTrackerService.filterTvProductionTracker(cid, payload).subscribe(
      (res: any) => {
        if (res && res.response) {
          this.todaysEpisodes = Array.isArray(res.response) ? res.response : [res.response];
        } else {
          this.todaysEpisodes = [];
        }
      },
      (err: any) => {
        console.error("Error fetching today's schedule", err);
        this.todaysEpisodes = [];
      }
    );
  }

  changeView(view: string) {
    this.currentView = view;
    this.generateCalendarDays();
  }

  generateCalendarDays() {
    if (this.currentView === 'Month') {
      this.calendarDays = [];
      const year = this.currentDate.getFullYear();
      const month = this.currentDate.getMonth();

      const firstDay = new Date(year, month, 1);
      const lastDay = new Date(year, month + 1, 0);

      const startDayIndex = firstDay.getDay();
      const prevMonthLastDay = new Date(year, month, 0).getDate();

      for (let i = startDayIndex - 1; i >= 0; i--) {
        this.calendarDays.push({
          dateNumber: prevMonthLastDay - i,
          fullDate: new Date(year, month - 1, prevMonthLastDay - i),
          isCurrentMonth: false,
          events: []
        });
      }

      for (let i = 1; i <= lastDay.getDate(); i++) {
        this.calendarDays.push({
          dateNumber: i,
          fullDate: new Date(year, month, i),
          isCurrentMonth: true,
          events: []
        });
      }

      const remainingCells = 42 - this.calendarDays.length;
      for (let i = 1; i <= remainingCells; i++) {
        this.calendarDays.push({
          dateNumber: i,
          fullDate: new Date(year, month + 1, i),
          isCurrentMonth: false,
          events: []
        });
      }
    } else if (this.currentView === 'Week') {
      this.weekDays = [];
      const current = new Date(this.currentDate);
      const day = current.getDay();
      const firstDayOfWeek = new Date(current);
      firstDayOfWeek.setDate(current.getDate() - day);

      for (let i = 0; i < 7; i++) {
        const d = new Date(firstDayOfWeek);
        d.setDate(firstDayOfWeek.getDate() + i);
        this.weekDays.push({
          fullDate: d,
          dayName: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'][d.getDay()],
          dateNumber: d.getDate(),
          events: []
        });
      }
    } else if (this.currentView === 'Day') {
      this.dayEvents = [];
    }

    this.loadFilteredEpisodes();
  }

  prev() {
    if (this.currentView === 'Month') {
      this.currentDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() - 1, 1);
    } else if (this.currentView === 'Week') {
      this.currentDate.setDate(this.currentDate.getDate() - 7);
      this.currentDate = new Date(this.currentDate);
    } else if (this.currentView === 'Day') {
      this.currentDate.setDate(this.currentDate.getDate() - 1);
      this.currentDate = new Date(this.currentDate);
    }
    this.generateCalendarDays();
  }

  next() {
    if (this.currentView === 'Month') {
      this.currentDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1, 1);
    } else if (this.currentView === 'Week') {
      this.currentDate.setDate(this.currentDate.getDate() + 7);
      this.currentDate = new Date(this.currentDate);
    } else if (this.currentView === 'Day') {
      this.currentDate.setDate(this.currentDate.getDate() + 1);
      this.currentDate = new Date(this.currentDate);
    }
    this.generateCalendarDays();
  }

  goToToday() {
    this.currentDate = new Date();
    this.generateCalendarDays();
  }

  loadFilteredEpisodes() {
    let startTimestamp = 0;
    let endTimestamp = 0;

    if (this.currentView === 'Month') {
      if (!this.calendarDays || this.calendarDays.length === 0) return;
      const year = this.currentDate.getFullYear();
      const month = this.currentDate.getMonth();
      startTimestamp = new Date(year, month, 1, 0, 0, 0, 0).getTime();
      endTimestamp = new Date(year, month + 1, 0, 23, 59, 59, 999).getTime();
    } else if (this.currentView === 'Week') {
      if (!this.weekDays || this.weekDays.length === 0) return;
      const firstDay = this.weekDays[0].fullDate;
      const lastDay = this.weekDays[6].fullDate;
      startTimestamp = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate(), 0, 0, 0, 0).getTime();
      endTimestamp = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate(), 23, 59, 59, 999).getTime();
    } else if (this.currentView === 'Day') {
      startTimestamp = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), this.currentDate.getDate(), 0, 0, 0, 0).getTime();
      endTimestamp = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), this.currentDate.getDate(), 23, 59, 59, 999).getTime();
    }

    const payload = {
      startDate: startTimestamp,
      endDate: endTimestamp,
      priority: this.priority ? this.priority : null,
      episodeType: this.episodeType ? this.episodeType : null,
      episodeStatus: this.episodeStatus ? this.episodeStatus : null
    };

    const cid = Number(sessionStorage.getItem('cid')) || 0;

    this.isLoading = true;
    this.tvProductionTrackerService.filterTvProductionTracker(cid, payload).subscribe(
      (res: any) => this.handleResponse(res),
      (err: any) => this.handleError(err)
    );
  }

  handleResponse(res: any) {
    this.isLoading = false;
    if (res && res.response) {
      this.episodeList = Array.isArray(res.response) ? res.response : [res.response];
    } else {
      this.episodeList = [];
    }
    this.mapEpisodesToCalendar();
  }

  handleError(err: any) {
    console.error(err);
    this.isLoading = false;
    this.toastr.error("An error occurred while fetching data");
  }

  applyFilter(filterType?: string) {
    this.loadFilteredEpisodes();
  }

  resetFilters() {
    this.priority = '';
    this.episodeType = '';
    this.episodeStatus = '';
    this.currentView = 'Month';
    this.generateCalendarDays();
  }

  mapEpisodesToCalendar() {
    if (this.currentView === 'Month') {
      if (!this.calendarDays || this.calendarDays.length === 0) return;
      this.calendarDays.forEach(day => day.events = []);

      if (!this.episodeList) return;

      this.episodeList.forEach(episode => {
        if (!episode.shootDate || episode.shootDate === 0) return;
        const shootD = new Date(episode.shootDate);
        const matchDay = this.calendarDays.find(d =>
          d.fullDate.getDate() === shootD.getDate() &&
          d.fullDate.getMonth() === shootD.getMonth() &&
          d.fullDate.getFullYear() === shootD.getFullYear()
        );
        if (matchDay) {
          matchDay.events.push(episode);
        }
      });
    } else if (this.currentView === 'Week') {
      if (!this.weekDays || this.weekDays.length === 0) return;
      this.weekDays.forEach(day => day.events = []);

      if (!this.episodeList) return;

      this.episodeList.forEach(episode => {
        if (!episode.shootDate || episode.shootDate === 0) return;
        const shootD = new Date(episode.shootDate);
        const matchDay = this.weekDays.find(d =>
          d.fullDate.getDate() === shootD.getDate() &&
          d.fullDate.getMonth() === shootD.getMonth() &&
          d.fullDate.getFullYear() === shootD.getFullYear()
        );
        if (matchDay) {
          matchDay.events.push(episode);
        }
      });
    } else if (this.currentView === 'Day') {
      this.dayEvents = [];
      if (!this.episodeList) return;

      this.episodeList.forEach(episode => {
        if (!episode.shootDate || episode.shootDate === 0) return;
        const shootD = new Date(episode.shootDate);
        if (shootD.getDate() === this.currentDate.getDate() &&
          shootD.getMonth() === this.currentDate.getMonth() &&
          shootD.getFullYear() === this.currentDate.getFullYear()) {
          this.dayEvents.push(episode);
        }
      });
    }
  }

  getStageClass(status: string): string {
    switch (status) {
      case 'EDITOR_ASSIGNED': return 'stage-editor';
      case 'EDIT_COMPLETED': return 'stage-editor';
      case 'TITLE_ASSIGNED': return 'stage-title';
      case 'TITLE_COMPLETED': return 'stage-title';
      case 'GRAPHICS_ASSIGNED': return 'stage-graphics';
      case 'GRAPHICS_COMPLETED': return 'stage-graphics';
      case 'SEO_ASSIGNED': return 'stage-seo';
      case 'SEO_COMPLETED': return 'stage-seo';
      case 'QUALITY_CHECK_ASSIGNED': return 'stage-qc';
      case 'QUALITY_CHECK_COMPLETED': return 'stage-qc';
      case 'PUBLISHING_ASSIGNED': return 'stage-publishing';
      case 'PUBLISHING_COMPLETED': return 'stage-publishing';
      case 'COMPLETED': return 'stage-completed';
      case 'CREATED': return 'stage-creation';
      case 'EPISODE_CREATION': return 'stage-creation';
      default: return '';
    }
  }

  openEpisodeDetails(tvProductionTrackerId: any) {
    this.isLoading = true;
    this.tvProductionTrackerService.getEpisodeById(tvProductionTrackerId).subscribe(
      (res: any) => {
        this.isLoading = false;
        if (res && res.response) {
          this.selectedEpisode = res.response;
        } else {
          this.toastr.error('Episode details not found');
        }
        setTimeout(() => {
          const detailEl = document.getElementById('detail-top');
          if (detailEl) {
            detailEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }, 100);
      },
      (err: any) => {
        this.isLoading = false;
        this.toastr.error('Error fetching episode details');
      }
    );
  }

  closeEpisodeDetails() {
    this.selectedEpisode = null;
  }

  getProgress(status: string): number {
    switch (status) {
      case 'CREATED': return 10;
      case 'EDITOR_ASSIGNED': return 20;
      case 'EDIT_COMPLETED': return 30;
      case 'TITLE_ASSIGNED': return 40;
      case 'TITLE_COMPLETED': return 50;
      case 'GRAPHICS_ASSIGNED': return 60;
      case 'GRAPHICS_COMPLETED': return 70;
      case 'SEO_ASSIGNED': return 80;
      case 'SEO_COMPLETED': return 90;
      case 'QUALITY_CHECK_ASSIGNED': return 95;
      case 'QUALITY_CHECK_COMPLETED': return 98;
      case 'PUBLISHING_ASSIGNED': return 99;
      case 'PUBLISHING_COMPLETED': return 100;
      case 'COMPLETED': return 100;
      case 'PENDING': return 0;
      case 'EPISODE_CREATION': return 5;
      default: return 0;
    }
  }

  getWeekRangeText(): string {
    if (!this.weekDays || this.weekDays.length === 0) return '';
    const first = this.weekDays[0].fullDate;
    const last = this.weekDays[6].fullDate;
    return `${first.toLocaleString('en-US', { month: 'short' })} ${first.getDate()} - ${last.toLocaleString('en-US', { month: 'short' })} ${last.getDate()}, ${last.getFullYear()}`;
  }

  getEventStyle(event: any) {
    if (!event.shootTime) {
      return { top: '0px', height: '100px' };
    }

    let timeStr = event.shootTime;
    let d = new Date(`1970-01-01T${timeStr}`);

    if (isNaN(d.getTime())) {
      let match = timeStr.match(/(\d+):(\d+)\s*(AM|PM)/i);
      if (match) {
        let hrs = parseInt(match[1]);
        if (match[3].toUpperCase() === 'PM' && hrs < 12) hrs += 12;
        if (match[3].toUpperCase() === 'AM' && hrs === 12) hrs = 0;
        d = new Date();
        d.setHours(hrs, parseInt(match[2]), 0, 0);
      } else {
        d = new Date();
        d.setHours(8, 0, 0, 0); // fallback
      }
    }

    let hours = d.getHours();
    let mins = d.getMinutes();

    // Calendar starts at 6 AM, goes to 8 PM (14 hours)
    const startHour = 6;
    const pxPerHour = 80; // Each hour slot is 80px high

    let top = (hours - startHour + (mins / 60)) * pxPerHour;
    if (top < 0) top = 0;

    let height = 1.5 * pxPerHour; // Default 1.5 hours height

    return {
      top: `${top}px`,
      height: `${height}px`
    };
  }

  closePopUp() {
    document.getElementById("closeModalButton1")?.click();
    document.getElementById("closeModalButton2")?.click();
    document.getElementById("closeModalButton3")?.click();
    document.getElementById("closeViewModalButton")?.click();

    this.episodeForm.reset();
    this.formSubmit = false;
  }

  addEpisode() {
    if (this.formSubmit) return;
    this.formSubmit = true;

    if (this.episodeForm.invalid) {
      this.formSubmit = false;
      this.toastr.error("Please fill required fields");
      return;
    }

    const payload = {
      version: 0,
      isActive: true,
      description: "",
      episodeId: 0,
      episodeName: this.episodeForm.get('episodeName').value,
      episodeType: this.episodeForm.get('episodeType').value,
      episodeStatus: 'CREATED',
      episodePublishedOn: 0,
      episodeYouTubeURL: this.episodeForm.get('episodeYouTubeURL').value,
      anchorUser: this.episodeForm.get('anchorUser').value,
      guest1: this.episodeForm.get('guest1').value,
      guest2: this.episodeForm.get('guest2').value,
      director: this.episodeForm.get('director').value,
      shootDate: this.episodeForm.get('shootDate').value ? new Date(this.episodeForm.get('shootDate').value).getTime() : 0,
      shootTime: this.episodeForm.get('shootTime').value,
      assignToEditorOnDate: 0,
      editorUser: "",
      editStartDate: 0,
      editEndDate: 0,
      noOfDaysToEdit: 0,
      noOfHoursToEdit: 0,
      assignToTitleTeamOnDate: 0,
      titleCreationStartDate: 0,
      titleCreationEndDate: 0,
      titleCreationUser: "",
      suggestedTitles: [],
      approvedTitle: "",
      assignToGraphicsTeamOnDate: 0,
      graphicsUser: "",
      graphicsCreationStartDate: 0,
      graphicsCreationEndDate: 0,
      assignToSEOTeamOnDate: 0,
      seoTeamStartDate: 0,
      seoTeamEndDate: 0,
      seoUser: "",
      suggestedSEOTitles: [],
      approvedSeoTitle: "",
      qualityCheckUser: "",
      assignToQualityCheckTeamOnDate: 0,
      qualityCheckStartDate: 0,
      publishingUser: "",
      assignToPublishingTeamOnDate: 0,
      publishingStartDate: 0,
      publishingEndDate: 0,
      editDueDate: 0,
      episodeDueDate: 0,
      titleDueDate: 0,
      graphicsDueDate: 0,
      seoDueDate: 0,
      qualityDueDate: 0,
      publishingDueDate: 0,
      commonNotes: [],
      currentStage: "EPISODE_CREATION",
      priority: "LOW",
      workflowStatus: "IN_PROGRESS",
      assignedUserId: 0,
      cid: this.cid
    };

    this.tvProductionTrackerService.createEpisode(payload).subscribe(
      (res: any) => {
        this.formSubmit = false;
        this.episodeForm.reset();
        this.closePopUp();
        this.loadFilteredEpisodes()
        this.toastr.success(res.message || 'Episode created successfully');
      },
      (err: any) => {
        this.formSubmit = false;
        this.toastr.error(err?.error?.errors?.[0]?.description || 'Error creating episode');
      }
    );
  }

}
